import { buildConfig } from '#common/i18n/config';
import deTranslation from './translations/de';
import enTranslation from './translations/en';

export const defaultLang = 'de';

export const i18nConfig = buildConfig({
    en: enTranslation,
    de: deTranslation
}, defaultLang);
